import React from "react";
import { infiiot, skylark, ni2, revolution } from "./imports";
import "./Collaborations.css";

const Collaborations = () => (
  <div>
    <div id="collaborations"></div>
    <section
      className="scrobits__brand_colab"
      // id="portfolio"
      data-aos="zoom-in"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <div className="scrobits__brand_colab_heading">
        {" "}
        <h1 className="gradient__text"> We work with the Best Partners </h1>
      </div>
      <div className="collab-logo-section">
        {/* <marquee behavior="scroll" direction="right" scrollamount="50"> */}
        <div className="collab-logo">
          <img
            className="portfolio-logo"
            src={infiiot}
            alt="InfiIoT technologies icon"
          />
        </div>
        <div className="collab-logo">
          <img
            // className="portfolio-logo"
            src={ni2}
            alt="ni2 designs icon "
          />
        </div>
        <div className="collab-logo">
          <img
            style={{ marginTop: "15%" }}
            className="portfolio-logo"
            src={skylark}
            alt="skylark technologies icon"
          />
        </div>
        <div className="collab-logo">
          <img
            style={{ marginTop: "-15%" }}
            className="portfolio-logo"
            src={revolution}
            alt="revolution IT icon"
          />
        </div>
      </div>
      {/* </marquee> */}
    </section>
  </div>
);

export default Collaborations;
